/**
 * Authentication and permission error patterns
 * Extracted from constants.ts to reduce file size
 */

import type { UserFriendlyError } from "../types";
import { getLoginSessionExpiredUserFriendlyError } from "../helpers/loginSiteTextUserFriendlyErrors";
import { peekPublicUiOptions } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";
import { organizationDemonstrativeTarget, organizationToPhrase } from "@Front/Utils/publicSiteBranding";

/**
 * Auth et permissions error patterns
 */
export const authErrorPatterns: Array<{
	pattern: RegExp;
	message: UserFriendlyError | ((match: RegExpMatchArray) => UserFriendlyError);
}> = [
	{
		pattern: /unauthorized without rules/i,
		message: {
			title: "Droits insuffisants",
			message: "Votre compte ne dispose pas des permissions nécessaires pour cette action. Contactez votre administrateur pour obtenir les droits requis.",
			canRetry: false,
		},
	},
	{
		pattern: /unauthorized with those rules/i,
		message: {
			title: "Permission manquante",
			message: "Vous n'avez pas les droits nécessaires pour effectuer cette action avec votre rôle actuel. Contactez votre administrateur pour obtenir les permissions requises.",
			canRetry: false,
		},
	},
	{
		pattern: /unauthorized by matrix/i,
		message: {
			title: "Accès refusé",
			message: "Votre rôle ne vous permet pas d'effectuer cette action. Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.",
			canRetry: false,
		},
	},
	{
		pattern: /unauthorized with this office/i,
		message: (_match: RegExpMatchArray): UserFriendlyError => ({
			title: peekPublicUiOptions().uses_estate_workspace_terms_in_ui_copy
				? "Accès refusé à cette étude"
				: `Accès refusé ${organizationToPhrase()}`,
			message: `Vous n'avez pas accès à ${organizationDemonstrativeTarget()} ou à cette ressource. Vérifiez que vous êtes bien connecté avec le bon compte ou que le partage a été configuré.`,
			canRetry: false,
		}),
	},
	{
		pattern: /unauthorized with this user/i,
		message: {
			title: "Accès refusé à cette ressource",
			message: "Vous n'avez pas les droits nécessaires pour accéder à cette ressource. Seuls les utilisateurs autorisés ou les parties prenantes peuvent y accéder.",
			canRetry: false,
		},
	},
	{
		pattern: /invalid token|token expired|token has been revoked|missing token|error while verifying token|invalid token payload/i,
		message: (): UserFriendlyError => getLoginSessionExpiredUserFriendlyError(),
	},
];

